var map = {
	"./product-HS-1.svg": 1241,
	"./product-HS-10.svg": 1242,
	"./product-HS-14.svg": 1243,
	"./product-HS-2.svg": 1244,
	"./product-HS-3.svg": 1245,
	"./product-HS-4.svg": 1246,
	"./product-HS-5.svg": 1247,
	"./product-HS-6.svg": 1248,
	"./product-HS-7.svg": 1249,
	"./product-HS-8.svg": 1250,
	"./product-HS-9.svg": 1251,
	"./product-SITC-0.svg": 1252,
	"./product-SITC-1.svg": 1253,
	"./product-SITC-10.svg": 1254,
	"./product-SITC-2.svg": 1255,
	"./product-SITC-3.svg": 1256,
	"./product-SITC-4.svg": 1257,
	"./product-SITC-5.svg": 1258,
	"./product-SITC-6.svg": 1259,
	"./product-SITC-7.svg": 1260,
	"./product-SITC-8.svg": 1261,
	"./product-SITC-9.svg": 1262
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1190;